<template>
  <footer id="scoreContainer" v-show="currentScore > 0">
    <progress id="formProgress" class="progress is-success" :value="currentScore" max="100">
      {{ currentScoreText }}
    </progress>
  </footer>
</template>

<script>
export default {
  computed: {
    voteRequirement() {
      return this.$store.state.vote_requirement;
    },
    currentScore() {
      return (this.$store.state.vote_count / this.voteRequirement) * 100;
    },
    currentScoreText() {
      return `${this.$store.state.vote_count} / ${this.voteRequirement}`;
    },
  },
};
</script>
